module.exports = __webpack_public_path__ + "static/img/20007 (1).85a9977.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20007 (1).webp
// module id = RX46
// module chunks = 14